import styled from '@emotion/styled'

import { Flex } from '../../../App/Components'

export const PageHeading = styled.h1`
  margin: 0;
  padding: 0;
`

export const FilterButtonContainer = styled(Flex)`
  padding: 1rem 1rem;
  box-shadow: 0 0 5px 2px rgba(0, 0, 0, 0.1);
  border-radius: 7px;
  background-color: #fafafa;
`

export const FilterButton = styled.a<{
  active?: boolean
}>`
  padding: 0.5rem 1rem;
  border-radius: 7px;
  background-color: ${({ active }) => (active ? '#005cdb' : null)};
  color: ${({ active }) => (active ? 'white' : null)};
  &:hover {
    color: white;
    background-color: #005cdb;
  }
`

export const CardImg = styled.img`
  position: absolute;
  width: 128px;
  bottom: -30%;
  right: -14%;
  height: auto;
`
